import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {DxFileUploaderComponent} from "devextreme-angular";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {each} from "async";
import {ServerService} from "../../../services/server.service";
import {DialogService} from "../dialog/dialog.service";
import {DataService} from "../../../services/data.service";
import {GuiService} from "../../../services/gui.service";

@Component({
   selector: 'app-form-assistenza',
   templateUrl: './form-assistenza.component.html',
   styleUrls: ['./form-assistenza.component.scss']
})
export class FormAssistenzaComponent implements OnInit, AfterViewInit {

   @ViewChild("fileUpload") fileUpload?: DxFileUploaderComponent

   frmGrpAssistenza: UntypedFormGroup = new UntypedFormGroup({
      from: new UntypedFormControl({value:this.dataSrv.user.DisplayName, disabled:true}, {validators:[Validators.required]}),
      email: new UntypedFormControl({value:this.dataSrv.user.data.email, disabled:true}, {validators:[Validators.required, Validators.email]}),
      title: new UntypedFormControl('', {validators:[Validators.required]}),
      body: new UntypedFormControl('', {validators:[Validators.required]}),
   });
   attachments:any[] = []

   constructor(private serverSrv: ServerService,
               private dataSrv: DataService,
               private guiSrv: GuiService,
               private dialogSrv: DialogService) { }

   ngOnInit(): void {}

   ngAfterViewInit(): void {
   }

   toBase64(file, next){
      var reader = new FileReader();
      reader.onloadend = (e:any) => {
         if(e.target.error){
            next(e.target.error)
         }else{
            let i = e.target.result.indexOf(",")
            this.attachments.push({
               data: e.target.result.substring(i+1),
               filename: file.name,
               "mime-type": file.type
            })
            next(null, e.target.result)
         }
      };
      reader.readAsDataURL(file);
   }

   clickInvia() {
      if(this.frmGrpAssistenza.valid){
         this.guiSrv.showLoading()
         let data = this.frmGrpAssistenza.getRawValue()
         this.attachments = []
         if(this.fileUpload?.value){

            let maxSize = 0
            for (const i in this.fileUpload.value) {
               let size = this.fileUpload.value[i].size
               maxSize += size
            }

            if (maxSize > 32000000){
               this.dialogSrv.showError({title:"Attenzione!", err:'Non caricare file superiori a 30Mb' })
               this.guiSrv.hideLoading()
               return
            }

            console.log(this.fileUpload?.value)
            each(this.fileUpload?.value, (f, next)=> this.toBase64(f, next), (err)=>{
               data.attachments = this.attachments
               this.serverSrv.post(`/api/assistenze`, data).then(res=>{
                  this.frmGrpAssistenza.get('title')?.reset()
                  this.frmGrpAssistenza.get('body')?.reset()
                  this.fileUpload?.instance.reset()
                  this.dialogSrv.showToastSuccess({title:"Invio Richiesta assistenza", msg: "Richiesta inviata correttamente"})
                  this.guiSrv.hideLoading()
               }).catch(err=>{
                  this.dialogSrv.showError({title:"Impossibile inviare la richiesta", err:err })
                  this.guiSrv.hideLoading()
               })
            })
         }
      }else{
         this.frmGrpAssistenza.markAllAsTouched()
         console.warn("Forn non valido")
      }
   }

   checkTitle($e) {
      let charRepeats = function(str) {
         str = str.replace(/\s+/g,"_");
         return /(\S)(\1{2,})/g.test(str);
      }

      if (charRepeats($e.target.value) || $e.target.value.length < 10){
         this.dialogSrv.showError({err:"Attenzione, scrivi il titolo della richiesta in modo esplicativo"})
         this.frmGrpAssistenza.get('title')?.reset()
      }
   }

   clickResetFile() {
      this.fileUpload?.instance.reset()
   }

}

